import React, { useRef } from 'react'
import { VideoJsPlayer, VideoJsPlayerOptions } from 'video.js'
import VideoJS from './VideoJS'

interface ILink {
  link: string
}

const VideoPlayer: React.FC<ILink> = ({ link }) => {
  const playerRef = useRef<VideoJsPlayer | null>(null)

  const videoJsOptions: VideoJsPlayerOptions = {
    autoplay: true,
    controls: true,
    fluid: true,
    sources: [
      {
        src: link,
        type: 'video/mp4',
      },
    ],
  }

  const handlePlayerReady = (player: VideoJsPlayer) => {
    player.on(player, 'ended', () => {
      player.currentTime(0)
    })
    playerRef.current = player
  }

  return <div data-vjs-player>{link && <VideoJS options={videoJsOptions} onReady={handlePlayerReady} />}</div>
}
export default VideoPlayer
